/* eslint-disable */
import * as types from './mutation-types'
import ngWordApi from '../../../api/ng-word'
import FinePlayGroupsApi from '../../../api/fine-plays'
import SurveysApi from '../../../api/questionnaire'
import notificationApi from '../../../api/notification'

const getNGWords = async ({commit}) => {
  const res = await ngWordApi.get()
  commit(types.SET_NG_WORDS, res.data.data)
}
const getUnreadFineplayApprove = async ({commit}) => {
  const res = await FinePlayGroupsApi.get({active: false})
  commit(types.SET_UNREAD_FINEPLAY_APPROVE, res.data.data)
}
const getNotifications = async ({commit}) => {
  const res = await notificationApi.get()
  commit(types.SET_NOTIFICATIONS, res.data.data)
}
const addNGWord = ({commit}, ngWord) => {
  commit(types.ADD_NGWORD, ngWord)
}
const updateNGWord = ({commit}, ngWord) => {
	commit(types.UPDATE_NGWORD, ngWord)
}
const deleteNGWord = ({commit}, ngWord) => {
	commit(types.DELETE_NGWORD, ngWord)
}
const getNumberSurveyNotComplete = async ({commit}) => {
  const res = await SurveysApi.count()
  commit(types.SET_TOTAL_NOT_COMPLETE_SURVEY, res.data)
}
const completeSurvey = ({commit}) => {
  commit(types.COMPLETE_SURVEY)
}

export default {
  getNGWords,
  getUnreadFineplayApprove,
  getNotifications,
  addNGWord,
  updateNGWord,
  deleteNGWord,
  getNumberSurveyNotComplete,
  completeSurvey
}



// WEBPACK FOOTER //
// ./src/store/modules/masterData/actions.js